import React from "react";
import { FormComponent } from "../../../react-core/Html/FormComponent";
import { RadiosEditor } from "../../../react-core/Html/RadiosEditor";
import { CustomerStatus } from "../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { UserClaim } from "../../../Wrap/Constants/Enums/UserClaim";
import { CustomerNewProductLink } from "../../../Wrap/Models/Models/Customer/CustomerNewProductLink";
import { PersonalDetail } from "../../../Wrap/Models/Models/Customer/PersonalDetail";
import { Alert } from "../../Shared/Components/Alert";
import { AlertType } from "../../Shared/Entities/Constants/AlertConstants";
import { Permission } from "../../Shared/Permission/Permission";
import { ClientRecordTab } from "./Clients/ClientRecord/Resource/Contents";
import { ClientRecordStore } from "./Clients/ClientRecord/Store/Variable";

interface ISelectAccountLightboxProps {
    errorMsg: string;
    links: CustomerNewProductLink[];
    customerId: number;
    displayNewBusiness: boolean;
}

interface ISelectAccountLightboxState {
    selectedAccount: CustomerNewProductLink;
    clientdetail: PersonalDetail;
}

export class SelectAccountLightbox extends FormComponent<ISelectAccountLightboxProps, ISelectAccountLightboxState> {
    constructor(props: any) {
        super(props);
        this.state = {
            selectedAccount: null,
            clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail],
        };
        this.subscribeToStore(ClientRecordStore, () => {
            this.setState({ clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail] });
        });
    }

    public render(): JSX.Element {
        return (
            <>
                {this.props.errorMsg || this.state.clientdetail?.CustomerStatus == CustomerStatus.Deceased ? (
                    <Alert alertType={AlertType.Error} message={this.props.errorMsg} />
                ) : (
                    <>
                        <div>
                            <RadiosEditor
                                options={this.props.links}
                                selected={this.state.selectedAccount}
                                onChange={(v) => {
                                    this.setState({
                                        selectedAccount: v,
                                    });
                                }}
                                getText={(o) => `${o.Account?.AccountName} - ${o.Account?.HeadClAccountId}`}
                            />
                            <br />
                            {this.state.selectedAccount && !this.state.selectedAccount?.IsActive && (
                                <Alert alertType={AlertType.Error} message={this.props.errorMsg} />
                            )}
                            <button
                                className="btn secondary mt-5"
                                onClick={() => window.location.assign(this.state.selectedAccount.Link)}
                                disabled={!this.state.selectedAccount || !this.state.selectedAccount.IsActive}
                            >
                                Next
                            </button>
                        </div>
                        {this.props.displayNewBusiness && (
                            <Permission userClaim={UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite}>
                                <>
                                    <br />
                                    OR
                                    <br />
                                    <button
                                        className="btn secondary mt-10"
                                        onClick={() =>
                                            window.location.assign(
                                                "/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=" +
                                                    this.props.customerId
                                            )
                                        }
                                    >
                                        Create new account
                                    </button>
                                </>
                            </Permission>
                        )}
                    </>
                )}
            </>
        );
    }
}
